<template>
  <div class="">
    <Wait_Skeleton v-if="!IsWait" />

    <Card class="h-100" v-if="IsWait">
      <template #title> Kullanıcı Ayarları </template>
      <template #content>

        <Tabs value="0" scrollable>
          <TabList>
            <Tab value="0" class="flex items-center gap-2" >
              <i class="pi pi-user"></i>
              Profilim
            </Tab>
            <Tab value="1" class="flex items-center gap-2">
              <i class="pi pi-key"></i>
              Şifre Değiştir
            </Tab>
            <Tab value="2" class="flex items-center gap-2">
              <i class="pi pi-megaphone"></i>
              Duyuru Tercihleri
            </Tab>
            <Tab value="3" class="flex items-center gap-2">Blank</Tab>
          </TabList>
          <TabPanels>
            <TabPanel value="0">
              <Profil />
            </TabPanel>
            <TabPanel value="1">
              <Sifre />
            </TabPanel>
            <TabPanel value="2">
              <DuyuruTercihleri /> 
            </TabPanel>
          </TabPanels>
        </Tabs>

      </template>
    </Card>
  </div>
</template>

<script>
// import GlobalServis from "../../../services/GlobalServis";
import Profil from "./AyarComponent/Profil.vue";
import Sifre from "./AyarComponent/Sifre.vue";
import DuyuruTercihleri from "./AyarComponent/DuyuruTercihleri.vue";

export default {
  data() {
    return {
      IslemYapiliyor: false,
      IsWait: false,


      // Validation Elements
      // Valid: {
      //     Ad: false,

      // }
    }
  },
  methods: {
    handleClick() {
      if (this._FormCheck()) { return; }
      this.IslemYapiliyor = true;

      // let data = {
      //     Ad: this.Ad,
      //     PasifMi: this.PasifMi,
      //     pKarakteristik: this.Karakteristik,
      //     pKategori: this.Kategori,
      //     Aciklama: this.Aciklama,
      // };

      // GlobalServis.GlobalServis("POST", "SetUrun", data).then((res) => {
      //     if (res.status == 200 && res.data == "") {
      //         this.$toast.add({
      //             severity: "success",
      //             summary: "Başarılı",
      //             detail: "Urun oluşturulmuştur",
      //             life: 3000,
      //         });
      //         this._ResetForm();
      //         this.$router.push({ path: "/Urun/UrunListesi" });
      //     } else if (res.status == 200 && res.data != "") {
      //         this.$toast.add({
      //             severity: "warn",
      //             summary: "Uyarı",
      //             detail: res.data,
      //             life: 3000,
      //         });
      //     } else {
      //         this.$toast.add({
      //             severity: "error",
      //             summary: "Hata",
      //             detail: "Hata oldu",
      //             life: 3000,
      //         });
      //     }
      // }).then(() => {
      //     this.IslemYapiliyor = false;
      // });

    },
    _ResetForm() {

    },
    _FormCheck() {
      let Check = false;
      // if (this.Ad === "") {
      //     this.Valid.Ad = true;
      //     this.$toast.add({ severity: "warn", summary: "Uyarı", detail: "Ad girin", life: 3000, });
      //     Check = true;
      //     return Check;
      // } else { this.Valid.Ad = false; Check = false; }
      return Check;
    },

  },
  mounted() {

    this.IsWait = true;
  },
  components: {
    Profil,
    Sifre,
    DuyuruTercihleri
  },

}
</script>
